import { createFileRoute } from '@tanstack/react-router'
import Button from '@/components/Button'
import bg2 from '@/assets/bg8.webp'

export const Route = createFileRoute('/_auth/$')({
  component: NotFoundPage,
})

function NotFoundPage() {
  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 bg-primary">
      <div className="absolute inset-0 bg-cover bg-center opacity-50" style={{ backgroundImage: `url(${bg2})` }} />
      <div className="max-w-2xl mx-auto text-center relative z-10">
        {/* Main Heading */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-base text-gray-900 mb-4">
          Hmm, we can't seem to find this page!
        </h1>
        {/* <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6">
    
        </h2> */}

        {/* Descriptive Text */}
        <p className="text-lg sm:text-xl text-gray-700 mb-8 leading-relaxed">
          Looks like you took a wrong turn. Let's try to get you back on track.
        </p>

        {/* Shield Icon */}
        {/* <div className="flex justify-center mb-8">
          <div className="w-24 h-24 sm:w-28 sm:h-28 bg-purple-600 rounded-lg flex items-center justify-center">
            <svg 
              width="48" 
              height="48" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="text-white"
            >
              <path 
                d="M12 2L4 5V11C4 16.55 7.84 21.74 12 23C16.16 21.74 20 16.55 20 11V5L12 2Z" 
                fill="currentColor"
              />
              <path 
                d="M12 6L8 8V12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12V8L12 6Z" 
                fill="#E6D1FF"
              />
              <path 
                d="M12 10L10 11V13C10 13.55 10.45 14 11 14H13C13.55 14 14 13.55 14 13V11L12 10Z" 
                fill="#B38CFF"
              />
            </svg>
          </div>
        </div> */}

        {/* Primary CTA Button */}
        <div className="mb-6">
          <Button
            to="/"
            variant="primary"
            size="large"
            className="px-8 py-4 text-xl font-semibold bg-purple-600 hover:bg-purple-700"
          >
            Homepage Dashboard →
          </Button>
        </div>
        {/* Secondary Links */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 mb-12 w-full">
          <Button
            to="/scam-library"
            variant="outline-purple"
            className="flex-1 py-4 text-xl font-semibold hover:text-purple-700 hover:bg-purple-50 px-4 py-2"
          >
            Visit Scam Library
          </Button>
          <Button
            to="/contact-support"
            variant="outline-purple"
            className="flex-1 py-4 text-xl font-semibold hover:text-purple-700 hover:bg-purple-50 px-4 py-2"
          >
            Contact Support
          </Button>
        </div>

        {/* Did you know? Tip Box */}
        <div className="bg-gray-50 shadow-sm rounded-lg p-6 text-left  mx-auto">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className="text-gray-400"
              >
                <path 
                  d="M13 2L3 14H12L11 22L21 10H12L13 2Z" 
                  stroke="#7023ff" 
                  strokeWidth="1.5" 
                  fill="none" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-gray-900 mb-2">While you're here, did you know?</h3>
              <p className="text-gray-700 text-base leading-relaxed">
                Scammers often spoof phone numbers to look like your bank. Always hang up and call back on the official number.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
